module.exports = __webpack_public_path__ + "static/media/listen_story_nep.a92debb2.svg";